<template>
  <div>
    <v-btn color="color1" class="white--text" @click="expand = true">
      Categories
    </v-btn>

    <v-navigation-drawer
      v-model="expand"
      fixed
      width="500px"
      class="foreground"
      temporary
    >

      <category-card></category-card>

    </v-navigation-drawer>
  </div>
</template>

<script>
import CategoryCard from './Card'
import CTreeView from '@/components/ui/tree-view/C-TreeView'
import Vue from 'vue'

export default {
  components: {
    CTreeView,
    CategoryCard
  },
  data () {
    return {
      expand: false,
    }
  }
}
</script>
